export default {
  questions: {
    openConversational: {
      openEndPlaceholder: "Пожалуйста, введите ваш текст здесь",
      conversationalPlaceholder: "Пожалуйста, введите ваш ответ здесь",
      conversationClosed: "Разговор закрыт.",
      conversationalDisclaimer: "Последующие вопросы будут сгенерированы ИИ на основе ваших ответов."
    },
    openText: {
      openEndPlaceholder: "Пожалуйста, введите ваш текст здесь"
    },
    multiText: {
      fieldPlaceholder: 'Ответ {number}',
      instruction: 'Введите ниже не менее {count} ответа, по одному в каждое текстовое поле | Введите ниже не менее {count} ответов, по одному в каждое текстовое поле',
      instructionWithoutMinimum: 'Введите ниже свои ответы, по одному в каждое текстовое поле',
      minimumEntries: 'Пожалуйста, введите не менее {count} ответа, чтобы продолжить. | Пожалуйста, введите не менее {count} ответов, чтобы продолжить.',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'Бренд {number}',
        minimumEntries: 'Пожалуйста, введите не менее {count} бренда, чтобы продолжить. | Пожалуйста, введите не менее {count} брендов, чтобы продолжить.'
      }
    },
    multiselect: {
      caption: "Выберите все подходящие варианты"
    },
    rankOrder: {
      enterRankOrder: "Введите порядок ранжирования",
      placeholder: "Перетащите сюда свои варианты для сортировки"
    },
    openNumeric: {
      label: "Числовой ввод"
    },
    complete: {
      message: "Спасибо за участие в опросе."
    },
    openVideo: {
      warning: "Пожалуйста, запишите видео перед продолжением.",
      uploadStatusUploading: "Пожалуйста, подождите, пока мы обработаем ваше видео, чтобы продолжить...",
      uploadStatusSuccess: "Загрузка выполнена успешно, можете продолжать.",
      uploadStatusError: "Загрузка не завершена, пожалуйста, попробуйте снова."
    }
  },
  errors: {
    node: {
      text_invalid_email: 'Введите действительный адрес электронной почты',
      text_invalid_phone: 'Введите действительный номер телефона',
      text_invalid_us_zip: 'Введите действительный почтовый индекс США (ZIP)',
      text_invalid_ca_postal: 'Введите действительный канадский почтовый индекс',
      text_invalid_uk_postal: 'Введите действительный британский почтовый индекс',
      text_invalid_custom: 'Введите действительный {fieldName}',
      text_min_chars: 'Введите не менее {min} символов',
      text_max_chars: 'Введите не более {max} символов',
      text_alpha_not_allowed: 'Допускаются только цифры',
      text_numeric_not_allowed: 'Допускаются только буквы'
    },
    external: {
      invalid: 'Ответ на этот вопрос недействителен.',
      required: 'Необходимо ответить на этот вопрос.',
      singlechoice_required: 'Пожалуйста, выберите вариант, прежде чем продолжить.',
      numeric_required: 'Пожалуйста, выберите оценку, прежде чем продолжить.',
      text_required: 'Пожалуйста, введите ответ, прежде чем продолжить.',
      bigtext_required: 'Пожалуйста, введите ответ, прежде чем продолжить.',
      singlechoiceother_incomplete: 'Пожалуйста, введите ответ, прежде чем продолжить.',
      multiselectother_incomplete: 'Пожалуйста, введите ответ, прежде чем продолжить.',
      numeric_invalid: 'Пожалуйста, введите корректное число, прежде чем продолжить.',
      radiogrid_required: 'Пожалуйста, выберите вариант для каждой строки, прежде чем продолжить.',
      incomplete: 'Полностью завершите этот вопрос, прежде чем продолжить.',
      multiselect_min: 'Пожалуйста, выберите не менее {value} вариантов, прежде чем продолжить.',
      multiselect_max: 'Пожалуйста, выберите не более {value} вариантов, прежде чем продолжить.',
      multiselectother_min: 'Пожалуйста, выберите не менее {value} вариантов, прежде чем продолжить.',
      multiselectother_max: 'Пожалуйста, выберите не более {value} вариантов, прежде чем продолжить.',
      multiselectgrid_min: 'Пожалуйста, выберите не менее {value} вариантов для каждой строки, прежде чем продолжить.',
      multiselectgrid_max: 'Пожалуйста, выберите не более {value} вариантов для каждой строки, прежде чем продолжить.',
      rankorder_min: 'Пожалуйста, оцените не менее {value} элементов, прежде чем продолжить.',
      rankorder_max: 'Пожалуйста, оцените не более {value} элементов, прежде чем продолжить.'
    }
  }
}
